const React = require('react');
const T = require('prop-types');
const { FormProvider } = require('react-hook-form');


const internals = {};

module.exports = function PrimitiveForm(props) {

    const {
        title,
        methods,
        fields,
        formId,
        formConfig,
        formModel,
        formProps
    } = props;
    const FormElement = internals.getFormElement();
    const FormFieldsRenderer = internals.getFormFieldsRenderer();
    const FieldProvider = internals.getFieldProvider();

    return (
        <FormProvider {...methods}>
            <FieldProvider
                formConfig={formConfig}
                formMethods={methods}
                formModel={formModel}
            >
                <FormElement {...formProps}>
                    {!!title && <h2>{title}</h2>}
                    <FormFieldsRenderer
                        fields={fields}
                        formId={formId}
                        methods={methods}
                    />
                </FormElement>
            </FieldProvider>
        </FormProvider>
    );
};

module.exports.propTypes = {
    formId: T.string,
    title: T.string,
    methods: T.object.isRequired,
    formConfig: T.object.isRequired,
    formModel: T.object.isRequired,
    formProps: T.object.isRequired,
    fields: T.arrayOf(
        T.oneOfType([
            T.shape({
                name: T.string.isRequired,
                label: T.string,
                type: T.string,
                placeholder: T.string,
                required: T.bool,
                options: T.array
            }),
            T.shape({
                type: T.oneOf(['group']).isRequired,
                fields: T.array
            }),
            T.shape({
                type: T.oneOf(['title', 'explainer']).isRequired,
                text: T.string.isRequired
            })
        ])
    ).isRequired
};

internals.getFormElement = () => {

    if (!internals.FormElement) {
        const { default: Styled } = require('styled-components');

        internals.FormElement = Styled.form`
            display: flex;
            flex-direction: column;
            gap: 16px;
            width: 100%;
            margin: 0 auto;
        `;
    }

    return internals.FormElement;
};

internals.getFieldProvider = () => {

    if (!internals.FieldProvider) {
        internals.FieldProvider = require('./FieldContext').FieldProvider;
    }

    return internals.FieldProvider;
};

internals.getFormFieldsRenderer = () => {

    if (!internals.FormFieldsRenderer) {
        internals.FormFieldsRenderer = require('./FormFieldsRenderer');
    }

    return internals.FormFieldsRenderer;
};

module.exports.internals = internals;
